<template>
    <v-layout>
        <v-flex xs12 md12>
            <v-form>
                <v-tabs vertical v-model="tabs" color="#FAFAFA">
                    <v-tab href="#informacoes_artisticas">Informações Profissionais</v-tab>
                    <v-tab href="#informacoes_pessoais">Informações Pessoais</v-tab>

                    <v-tabs-items v-model="tabs" class="white">
                        <!--class="elevation-1"-->
                        <v-tab-item :key="0" :value="'informacoes_artisticas'">
                            <artista_form_artistico :artistdata="artist" @artist_data="artistData" />
                        </v-tab-item>

                        <v-tab-item :key="1" :value="'informacoes_pessoais'">
                            <persons_form
                                :is_company="artist.is_company"
                                :personsdata="persons"
                                @persons_data="personsData"
                            />
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-form>
        </v-flex>

        <modal_message
            :dialog_opened="modal_dialog.dialog_opened"
            :title="modal_dialog.title"
            :message="modal_dialog.message"
            :btn_1_text="modal_dialog.btn_1_text"
            :btn_2_text="modal_dialog.btn_2_text"
            @btn_1_clicked="modal_dialog.btn_1_evnt"
            @btn_2_clicked="modal_dialog.btn_1_evnt"
        />
    </v-layout>
</template>

<script>
import artista_form_artistico from "./artista_form_artistico";
import persons_form from "../persons/form_persons";
import ArtistService from "../../app/Rest/artist";
import modal_message from "../shared/modal_message";

var artistService = null;

export default {
    components: {
        artista_form_artistico,
        persons_form,
        modal_message
    },
    props: {
        //artist_id: Number
    },
    data() {
        return {
            tabs: null,
            artist: {},
            artist_id: null,
            persons: [],
            modal_dialog: {
                dialog_opened: false,
                title: null,
                message: null,
                btn_1_text: null,
                btn_2_text: null,
                btn_1_evnt: function() {},
                btn_2_evnt: function() {}
            }
        };
    },
    beforeCreate(){
          artistService = ArtistService.build();
          this.artist_id = this.$route.params.id
           //se não tem, não tem
            if (!this.artist_id ) {
                return;
            }
            //this.artist_id = this.$route.params.id;
            console.log("artist_id", this.artist_id);

            this.$store.dispatch("loading_full");
            artistService.getOne(this.artist_id).then(e => {
                this.artist = e.items.artist;
                this.persons = e.items.persons;
            }).finally(e=>{
                this.$store.dispatch("loading_full");
            });
    },
    created() {
      
       
    },

    mounted() {},

    methods: {
        salvar() {
            if (this.persons.length) {
                this.artist.persons = this.persons;
            }
            this.$store.dispatch("loading_full");
            artistService
                .salvar(this.artist)
                .then(e => {
                    if (e.items) {
                        this.persons = e.items.persons;
                        this.artist = e.items.artist;
                        this.modal_dialog.title = "Salvo com sucesso!";
                        this.modal_dialog.btn_1_text = "obrigado";
                        this.modal_dialog.btn_1_evnt = e => {
                            this.modal_dialog.dialog_opened = false;
                        };
                        this.modal_dialog.dialog_opened = true;
                    }
                })
                .finally(e => {
                    this.$store.dispatch("loading_full");
                });
        },
        personsData(persons) {
            this.persons = persons;
        },
        artistData(artist) {
            this.artist = artist;
        }
    }
};
</script>